import React from "react";
import VehicleDistributionDashboard from "../features/sales-dashboard/VehicleDistributionDashboard";

const ClientUserDashboard = () => {
  return <VehicleDistributionDashboard />;
};

export default ClientUserDashboard;
